export default {
  api_url: window.location.hostname.includes("ascensionapp.com")
    ? "https://api.ascensionapp.com"
    : "http://localhost:8000",
};

export const is_production = window.location.hostname.includes(
  "ascensionapp.com"
);
export const version = "0.0.12";
